export default __webpack_public_path__ + "static/media/mainImage@2x.f31abaf9.png";